const $ = require('jquery');

$(function(){
  var allForms = [];
  var anythingChanged = false;
  var submitting = false;

  window.addEventListener('beforeunload', function (e) {
    if(anythingChanged && ! submitting) {
      var confirmationMessage = 'It looks like you have been editing something. '
        + 'If you leave before saving, your changes will be lost.';
      (e || window.event).returnValue = confirmationMessage; //Gecko + IE
      return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
    }
  });

  $('form[method="post"]').each(function(index, formEl){
    var $form = $(formEl);
    if($form.data('form-locker') === 'off') return;
    var originalData = getFormElData(formEl);
    allForms.push({
      formEl: formEl
    });
    formEl.addEventListener('submit', function(){
      submitting = true;
      $('*[type="submit"]', formEl).each(function(i, el){
        el.disabled = true;
      });
      disableAll(formEl);
    });
    $(formEl.elements).change(function(){
      var currentData = getFormElData(formEl);
      if(currentData[this.name] == originalData[this.name]) {
        $(this).closest('div, tr, td').css('background-color', '');
      } else {
        $(this).closest('div, tr, td').css('background-color', '#cff');
      }
      if(formElDiffers(formEl, originalData)) {
        if(!anythingChanged) {
          anythingChanged = true;
          disableAll(formEl);
          // console.log('changes');
        }
      } else {
        anythingChanged = false;
        disableAll();
        // console.log('no more changes');
      }
    });
  });

  function getFormElData(formEl) {
    var data = {};
    $.each($(formEl).serializeArray(), function(i, d){
      data[d.name] = d.value;
    });
    return data;
  }

  function formElDiffers(formEl, data) {
    return differentValues(getFormElData(formEl), data);
  }

  function differentValues(a, b) {
    return Object.keys(a).some(function(key){
      if(a[key] != b[key]) {
        return true;
      }
    }) || Object.keys(b).some(function(key){
      if(b[key] != a[key]) {
        return true;
      }
    });
  }

  function disableAll(skipEl) {
    $(allForms).each(function(index, form){
      var formEl = form.formEl;
      var disabled = skipEl && (skipEl !== formEl);
      $(formEl.elements).each(function(index, el){
        var $el = $(el);
        if(disabled) {
          $el.data('______track_disabled_state', !!$el.prop('disabled'));
          $el.data('______track_readOnly_state', !!el.readOnly);
          $el.prop('disabled', true);
          el.readOnly = true;
        } else {
          $el.prop('disabled', $el.data('______track_disabled_state'));
          el.readOnly = $el.data('______track_readOnly_state');
        }
      });
    });
  }
});
